function isFunction(functionToCheck) {
    return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
}

export function shallowEqual(objA, objB) {
    if (objA === objB) return true;
    const aKeys = Object.keys(objA);
    const bKeys = Object.keys(objB);
    const len = aKeys.length;

    if (bKeys.length !== len) return false;

    for (let i = 0; i < len; i++) {
        const key = aKeys[i];
        const a = objA[key];
        const b = objB[key];
        if (a !== b && !(isFunction(a) && isFunction(b))) {
            return false;
        }
    }

    return true;
}

export function cleanEmptyValues(obj) {
    for (const propName in obj) {
        if (!obj[propName]) {
            delete obj[propName];
        }
    }
    return obj;
}

export const isEqual = (objA, objB) => {
    const type = Object.prototype.toString.call(objA);
    if (type !== Object.prototype.toString.call(objB)) return false;

    if (['[object Array]', '[object Object]'].indexOf(type) < 0) return false;

    const objALen = type === '[object Array]' ? objA.length : Object.keys(objA).length;
    const objBLen = type === '[object Array]' ? objB.length : Object.keys(objB).length;
    if (objALen !== objBLen) return false;

    const compare = (item1, item2) => {
        const itemType = Object.prototype.toString.call(item1);

        if (['[object Array]', '[object Object]'].indexOf(itemType) >= 0) {
            if (!isEqual(item1, item2)) return false;
        } else {
            if (itemType !== Object.prototype.toString.call(item2)) return false;

            if (itemType === '[object Function]') {
                if (item1.toString() !== item2.toString()) return false;
            } else {
                if (item1 !== item2) return false;
            }
        }
    };

    if (type === '[object Array]') {
        for (let i = 0; i < objALen; i++) {
            if (compare(objA[i], objB[i]) === false) return false;
        }
    } else {
        for (let key in objA) {
            if (objA.hasOwnProperty(key)) {
                if (compare(objA[key], objB[key]) === false) return false;
            }
        }
    }

    return true;
};
